import React, { Component, Fragment } from "react";
import AppContext from "../../contexts/AppContext";

class ApplicationError extends Component {
  render() {
    return (
      <AppContext.Consumer>
        {context => (
          <Fragment>
            {context.state.applicationError === true ? (
              <div className="applicationError">
                <div className="errorCenter">
                  <div className="noDataTitle">Error</div>
                  <div className="noDataComment">
                    Application error please contact the system administrator
                  </div>
                </div>
              </div>
            ) : null}
          </Fragment>
        )}
      </AppContext.Consumer>
    );
  }
}

export default ApplicationError;



// WEBPACK FOOTER //
// ./src/components/utilities/ApplicationError.js